module.exports = __webpack_public_path__ + "img/multi-mode-1.53bd8b30.png";